<template>
  <div id="image-note-wrap">
    <span class="title-and-exit">
      <input 
        type="text" 
        class="title-input"
        :value="title"
        @input="updateTitle"/>
      <button class="delete-note" @click="deleteNote">X</button>
    </span>
    <img src="" alt="">
  </div>
</template>

<script>
import Note from './Note.vue';

export default {
  name: "ImageNote",
  extends: Note,
  created() {
    this.type = 'image';
  }
}
</script>
<style lang="css">
  #image-note-wrap {
    width: 80%;
    margin: 0 0 1em;
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  #image-note-wrap .title-and-exit {
    display: flex;
    justify-content: space-between
  }

  #image-note-wrap .delete-note {
    font-size: 24px;
    color: #999999;
    text-align: center;
  }

  #image-note-wrap input {
    width: 100%;
    margin-bottom: 0.5em;
    font-size: 20px;
    border: none;
    border-bottom: 1px solid #2c3e50;
    border-radius: 0;
  }

  #image-note-wrap input:focus {
    border: 1px solid #2c3e50;
    border-radius: 3px;
  }

  /* #text-note-wrap textarea {
    height: 8em;
    max-height: 20em;
    border-radius: 2px;
    font-size: 16px;
    resize: vertical; 
  }

  #text-note-wrap textarea:focus {
    outline: none;
  } */
</style>